import {gql} from '@apollo/client';

const UPDATE_COUNTRY_BUS_COST_ENTRY_V2 = gql`
  mutation updateCountryBusCostEntryV2(
    $countryId: ID!
    $year: Int!
    $adblueCost: FuelCost
    $cleaningCost: Float
    $dieselCost: FuelCost
    $flixStandardCost: Float
    $legalCost: Float
    $lngCost: Float
    $otherCost: Float
    $overheadCost: Float
    $repairCostPerDistanceUnit: CostPerDistance
    $repairCostPerMonth: Float
    $tiresCost: TiresCost
  ) {
    updateCountryBusCostEntryV2(
      input: {
        countryId: $countryId
        year: $year
        adblueCost: $adblueCost
        cleaningCost: $cleaningCost
        dieselCost: $dieselCost
        flixStandardCost: $flixStandardCost
        legalCost: $legalCost
        lngCost: $lngCost
        otherCost: $otherCost
        overheadCost: $overheadCost
        repairCostPerDistanceUnit: $repairCostPerDistanceUnit
        repairCostPerMonth: $repairCostPerMonth
        tiresCost: $tiresCost
      }
    ) {
      adblueCost
      cleaningCost
      currency
      dieselCost
      flixStandardCost
      legalCost
      lngCost
      otherCost
      overheadCost
      repairCostPerDistanceUnit
      repairCostPerMonth
      tiresCost
      year
    }
  }
`;

export default UPDATE_COUNTRY_BUS_COST_ENTRY_V2;
